import styled from "styled-components";
import { SectionHeader, Section, SponsorsAside, SponsorsGrid, SponsorGridItem, AccentedText } from "../layout/style";

import JacobsPillowLogoImage from "../img/sponsors/jacobs_pillow.png";
import BostonFoundationLogoImage from "../img/sponsors/boston_foundation.png";
import MetaLabLogoImage from "../img/sponsors/metalab.svg";
import NortheasternLogoImage from "../img/sponsors/northeastern.png";
import KnightLogoImage from "../img/sponsors/KF_logo-stacked.png";
import ArtLabLogoImage from "../img/sponsors/ArtLab.png";
import { CreativeTeamAndSponsorsContainer } from "../layout/style";
import CreativeTeamTable from "../layout/CreativeTeamTable";

import QRCode from "../img/drw-demo/adobe-express-qr-code.svg";

const ContentContainer = styled.div`
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    margin-top: 50px;
margin-bottom: 50px;
`;

const RestyledSection = styled(Section)`
    margin: 0px;
    padding: 0px;

`;

const QRCodeContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    & img {
        width: 60%;
    }
`;

const LearnMoreContainer = styled.div`
  
border-top: 1px solid #CCCCCC;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 5px;
    padding-top: 5px;

    & p {
        width: 100%;
        flex: 1 0 100%;
        display: block;
        margin: 5px 0px;
        padding: 0px;
    }
`;

const LearnMoreColumn = styled.div`
    flex: 1 auto;
    margin: 0px;
    padding: 0px;

`;

const QRColumn = styled.div`
    flex: 1 0 40%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const CreativeTeamSlide = () => {

    return (<ContentContainer>


        <Section>
            <CreativeTeamAndSponsorsContainer>
                <CreativeTeamTable />
                <SponsorsAside>
                    <p id="pre-label">In addition, this work is supported by the following sponsors:</p>
                    <SponsorsGrid>
                        <SponsorGridItem>
                            <a target="_blank" href="https://www.jacobspillow.org/events/pillow-lab-ilya-vidrin/">
                                <img src={JacobsPillowLogoImage} />
                            </a>
                        </SponsorGridItem>
                        <SponsorGridItem>
                            <a target="_blank" href="https://www.tbf.org/">
                                <img src={BostonFoundationLogoImage} />
                            </a>
                        </SponsorGridItem>
                        <SponsorGridItem>
                            <a target="_blank" href="https://mlml.io/">
                                <img src={MetaLabLogoImage} />
                            </a>
                        </SponsorGridItem>
                        <SponsorGridItem>
                            <a target="_blank" href="https://knightfoundation.org/">
                                <img src={KnightLogoImage} />
                            </a>
                        </SponsorGridItem>
                        <SponsorGridItem>
                            <a target="_blank" href="https://camd.northeastern.edu/">
                                <img src={NortheasternLogoImage} />
                            </a>
                        </SponsorGridItem>
                        <SponsorGridItem>
                            <a target="_blank" href="https://artlab.harvard.edu/">
                                <img src={ArtLabLogoImage} />
                            </a>
                        </SponsorGridItem>
                    </SponsorsGrid>
                    <LearnMoreContainer>
                        <p><b>Want to learn more?</b> Reach out to us:</p>
                        <LearnMoreColumn>

                            <p>Steven Geofrey<br /><i>s.geofrey@northeastern.edu</i></p>
                            <p>Ilya Vidrin<br /><i>i.vidrin@northeastern.edu</i></p>
                        </LearnMoreColumn>
                        <QRColumn>
                            <QRCodeContainer>
                                <img src={QRCode} />
                            </QRCodeContainer>
                        </QRColumn>
                        <p><b>Follow the QR code above to read the full case study on this ongoing work.</b></p>

                    </LearnMoreContainer>
                </SponsorsAside>
            </CreativeTeamAndSponsorsContainer>
        </Section>



    </ContentContainer >);


}

export default CreativeTeamSlide;